module.exports = __webpack_public_path__ + "media/images/flags/64/Ecuador-42fcf1ae8da59582be80cc6d90523fe6.png";